export default __webpack_public_path__ + "static/media/section4-bg2-h5.df33735a.png";